import styles from "./PreviewSlide.module.scss";

function PreviewSlide({ preview, active }) {
  const isDark = !preview.bg.startsWith("#f") && !preview.bg.startsWith("#e");

  const barBg = isDark ? "rgba(255,255,255,0.09)" : "rgba(0,0,0,0.06)";

  const subColor = isDark ? "rgba(255,255,255,0.44)" : "rgba(0,0,0,0.36)";

  const softBg = isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.07)";

  const progressBg = isDark ? "rgba(255,255,255,0.07)" : "rgba(0,0,0,0.06)";

  const textColor = isDark || preview.bg === "#1e1e1e" ? "#fff" : "#1e1e1e";

  return (
    <div
      className={`${styles["dp-slide"]} ${
        active ? styles["on"] : styles["off"]
      }`}
      style={{
        background: preview.bg,
        "--bar-bg": barBg,
        "--sub-color": subColor,
        "--soft-bg": softBg,
        "--progress-bg": progressBg,
      }}
    >
      {/* Browser Chrome */}
      <div className={styles.chrome}>
        <span className={`${styles.dot} ${styles.red}`} />
        <span className={`${styles.dot} ${styles.yellow}`} />
        <span className={`${styles.dot} ${styles.green}`} />

        <div className={styles["url-bar"]}>
          <span className={styles["url-text"]}>
            sreeragvs.com/
            {preview.label.toLowerCase().replace(/\s/g, "-")}
          </span>
        </div>
      </div>

      {/* Mock UI */}
      <div className={styles["mock-ui"]}>
        <div className={styles.header}>
          <div>
            <div
              className={styles["title-line"]}
              style={{
                width: 90,
                background: preview.accent,
                opacity: 0.85,
              }}
            />
            <div className={styles["subtitle-line"]} />
          </div>

          <div
            className={styles.avatar}
            style={{ background: preview.accent }}
          />
        </div>

        <div className={styles["card-grid"]}>
          {[1, 2, 3].map((i) => (
            <div key={i} className={styles.card}>
              <div
                className={styles["card-title"]}
                style={{
                  width: "55%",
                  background: preview.accent,
                }}
              />
              <div className={styles["card-body"]} />
            </div>
          ))}
        </div>

        <div className={styles["list-box"]}>
          {[80, 55, 70, 40, 88].map((w, i) => (
            <div key={i} className={styles["list-item"]}>
              <div
                className={styles.bullet}
                style={{ background: preview.accent }}
              />
              <div className={styles["progress-track"]}>
                <div
                  className={styles["progress-fill"]}
                  style={{
                    width: `${w}%`,
                    background: preview.accent,
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        <div className={styles["button-row"]}>
          <div
            className={styles["button-primary"]}
            style={{ background: preview.accent }}
          />
          <div className={styles["button-secondary"]} />
        </div>
      </div>

      {/* Label */}
      <div
        className={styles.label}
        style={{
          background: preview.accent,
          color: textColor,
        }}
      >
        {preview.label}
      </div>
    </div>
  );
}

export default PreviewSlide;
